import React from 'react';
import ContactSection from '../components/sections/ContactSection';

const Contact = () => <div className="pt-20"><ContactSection /></div>;

export default Contact;
